export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11225.4b41ab58.jpg";